<template>
  <gh-invoke ref="inv" v-model="data" module="mes.business.mdl.structure.service" cls="StructureService"
    method="custom_query" :args="args" @start="" @complete="$emit('complete',data)">
    <template v-slot="{args,data,loading}">
      <slot :data="data" :loading="loading">
        <v-container style="background: white">
          <v-layout column>
            <v-layout row v-if="showToolbar" align-center ma-0 pa-0>
              <v-progress-linear color="success" :indeterminate="loading" v-show="loading"></v-progress-linear>
              <v-btn color="primary" outline icon @click="query">
                <v-icon>mdi-database-refresh</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
          <v-divider></v-divider>
          <gh-tree v-model="currentNode" :data="data" node-key="Id" :expand-on-click-node="false" default-expand-all>
            <div slot-scope="{node,data}">
              <slot name="node" :node="node" :data="data">
                {{data.Cd}} {{data.Name}}
                <span v-if="data.icon">
                  <v-icon color="success">{{data.icon}}</v-icon>
                </span>
                <span v-else>
                  <v-icon color="success">{{data.LevelIcon}}</v-icon>
                </span>
                <slot name="node-append" :node="node" :data="data">

                </slot>
              </slot>

            </div>
          </gh-tree>
        </v-container>

      </slot>
    </template>
  </gh-invoke>
</template>

<style scoped>

</style>

<script>
  import StructureNavigation from "./structureNavigation.ts";
  export default StructureNavigation;
</script>